import { Breadcrumb } from "@/components/ui/breadcrumb";
import { AlertsStateView } from "@/features/oversight/monitoring-alerts";

// Deferred (page-delivery-pipeline.md G6, 2026-09-23). No alert domain exists anywhere in
// the backend — the only alerting today is operator-side Prometheus rules, not multi-tenant
// and not queryable. See context/page_pipeline/BACKEND_GAPS.md row 17.
//
// The page renders the alerts register's real state surface (AlertsStateView) with the
// `unavailableReason` set, so the register's loading/empty/error/list branches are
// implemented and pinned by tests while the honest thing on screen stays "not available
// yet" — never a fabricated "No active alerts", which would claim an alerting service
// answered when none exists.
export default function MonitoringAlertsPage() {
  return (
    <div>
      <Breadcrumb items={[{ label: "Monitoring", href: "/monitoring" }, { label: "Alerts & Incidents" }]} />
      <AlertsStateView
        alerts={null}
        loading={false}
        error={null}
        unavailableReason="This is not available in your environment yet."
      />
    </div>
  );
}
